<template>
  <div>
    <CommonIndex :pageType="pageType" @showDetail="showDetail" />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import CommonIndex from '@/views/safety-device/component/common-index';
import { createDrawer } from '@triascloud/x-components';
import SmokeDetectorDetail from './smoke-detector-detail';
import { pageTypeEnum } from '@/views/safety-device/component/safety-utils';

@Component({
  components: {
    CommonIndex,
  },
})
export default class SmokeDetector extends Vue {
  // 智能烟感
  pageType = pageTypeEnum.smokeDetector;

  showDetail(record) {
    this.modalDrawer = createDrawer(
      () => (
        <SmokeDetectorDetail
          detailData={record}
          pageType={this.pageType}
          close={this.handleCloseModalDrawer}
        />
      ),
      {
        title: this.$t('safety.deviceDetail'),
        width: '720px',
        wrapClassName: 'deviceDetail',
      },
    );
  }
}
</script>

<style lang="less" module>
@import '../component/safety.less';
</style>
